import React, { createContext, useContext, useState } from 'react';

const LanguageContext = createContext();

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState('en');
  const toggle = () => setLang(prev => prev === 'en' ? 'ml' : 'en');
  return (
    <LanguageContext.Provider value={{ lang, setLang, toggle }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  return useContext(LanguageContext);
}

export function t(key, lang) {
  return translations[lang]?.[key] || translations['en'][key] || key;
}

export const translations = {
  en: {
    // Header
    home: 'Home',
    about: 'About',
    programs: 'Programs',
    services: 'Services',
    resources: 'Resources',
    contact: 'Contact',
    signIn: 'Sign In',
    getStarted: 'Get Started',

    // Hero
    heroBadge: 'Heal And Manifest Masterclass',
    heroHeadline1: 'Master Powerful Techniques To Heal From The Past And',
    heroHeadline2: 'Manifest Your Dream Life',
    heroSocial: 'More than',
    heroSocialBold: '1 Million+ People',
    heroSocialEnd: 'Have Experienced Big Transformation',
    coachName: 'Dr. Dinesh Mungath',
    coachCredentials: 'Entrepreneur, Author, Happiness Life Coach, LOA Certified Coach, Spiritual Healer, Mind Architect',
    morning: 'Morning',
    evening: 'Evening',
    date: 'Date',
    time: 'Time',
    platform: 'Platform',
    onZoom: 'On Zoom',
    duration: 'Duration',
    threeHours: '3 Hours',
    signUpNow: 'Sign Up Now for',
    seatsFilling: 'Seats Filling Fast!',
    seatsLeft: 'left',
    alreadyRegistered: 'already registered',
    morningTime: '9:30 AM - 12:30 PM (IST)',
    eveningTime: '5:30 PM - 8:30 PM (IST)',

    // Benefits
    joinTitle: 'Join The Masterclass If You Want To...',
    benefit1: 'Wake up with Clarity and Purpose Every Morning',
    benefit2: 'Attract Wealth, Abundance and Opportunities',
    benefit3: 'Feel More Confident While Making Decisions',
    benefit4: 'Overcome Stress, Anxiety and Overthinking',
    benefit5: 'Have a healthy, happy and loving Relationship',
    benefit6: 'See a Positive change in Health and Mindset',
    registerCta: 'Register For Masterclass At',

    // Learnings
    learnTitle: 'What You Will Learn In Masterclass',
    learn1Title: 'Break Free from Limiting Beliefs',
    learn1Desc: 'Identify and dissolve deep-rooted trauma and limiting beliefs that are holding you back. Learn how to move forward with a fresh mindset, so you can confidently take action towards your goals.',
    learn2Title: 'Master the Art of Manifestation',
    learn2Desc: 'Learn the science behind manifestation and how to make it work for you. These strategies helped 30,000 people attract health, wealth, love, and happiness into their lives.',
    learn3Title: 'Attract Healthy Relationships',
    learn3Desc: 'Discover how to stop repeating toxic patterns in relationships and how to replace old habits with new ones to attract positive, loving and supporting partner or how to improve your existing relationship.',
    learn4Title: 'Proven 7-Step Formula to Achieve Any Goal',
    learn4Desc: 'Get access to a simple formula that can be easily applied to any area of your life \u2013 health, wealth, career, or relationships. This formula is designed to give you clarity, focus, and the exact steps needed to reach your goals faster.',

    // Video Testimonials
    videoTitle: 'Heartwarming Testimonials From Past Attendees',

    // Coach Section
    meetCoach: 'Meet Your Coach',
    coachBio1: 'Dr. Dinesh is a certified healing and manifestation coach with over 10 years of experience.',
    coachBio2: 'Over these years, he has impacted over 1 Million people and personally helped 30,000+ people overcome past traumas and limiting beliefs by rewiring their brain and manifesting their goals.',
    coachBio3: 'He has worked with the best minds in personal development, including Jack Canfield, Tony Robbins, Marisa Peer, Dr. John DeMartini, Brian Tracy, Nick Vujicic, Blair Singer, and Robin Sharma.',
    coachBio4: 'Now Dr. Dinesh is on a mission to help 10 Million people become the best version of themselves.',
    followers: '1 Million+ Followers',
    loaCertified: 'LOA Certified',

    // Bonuses
    specialBonuses: 'Special Bonuses',
    unlockBonuses: 'Unlock Special Bonuses Worth',
    bonus1Title: '21 Day Abundance Challenge',
    bonus1Desc: 'Daily practices to rewire your money mindset and shift from scarcity to receiving',
    bonus2Title: "Ho'oponopono Meditation",
    bonus2Desc: 'A deep emotional cleansing meditation to release guilt, resentment and stuck energy',
    bonus3Title: '7 Day Letting Go Meditation',
    bonus3Desc: 'A guided journey to detach from pain, people and old patterns',
    bonus4Title: '21 Day Challenge to Beat Procrastination & Increase Productivity',
    bonus4Desc: 'Daily action prompts to break procrastination, build discipline and increase productivity',
    bonus5Title: 'The Miracle Morning Routine (90 Day Challenge)',
    bonus5Desc: 'A structured 90-day routine to build habits, focus and discipline for long-term transformation',
    bonusNote: 'Note: You will receive the bonuses after attending the masterclass.',
    worth: 'Worth',

    // Success Stories
    successTitle: 'Success Stories',

    // FAQs
    faqTitle: 'Frequently Asked Questions',
    faq1Q: 'Will I get a recording of the masterclass?',
    faq1A: "We don't provide recordings. We recommend you clear up your calendar for the webinar to get the best experience.",
    faq2Q: 'Who should attend the masterclass?',
    faq2A: 'Anyone who is looking to get over past traumas, and limiting beliefs, heal their mind, boost confidence, and manifest their biggest life goals to take action.',
    faq3Q: "I made the payment but didn't receive any email.",
    faq3A: 'Please check your inbox and spam folder for mail from info@dineshmungath.com. If you have still not received it, please send a mail to the same ID and the team will get back with the link.',
    faq4Q: 'How will I join the masterclass?',
    faq4A: 'You will receive a Zoom invite a few hours before in the WhatsApp group and on your registered email ID.',
    faq5Q: 'When will I get the Bonuses?',
    faq5A: 'You will get all the bonuses after attending the masterclass.',

    // Register
    registerNow: 'Register Now',
    limitedSeats: 'Limited seats available',
    yourName: 'Your Full Name',
    yourEmail: 'Your Email Address',
    yourPhone: 'Your Phone Number',
    payIndia: 'Pay',
    payIndiaMethod: '(India - Razorpay)',
    payIntl: 'Pay $1.19 USD (International - Stripe)',
    securePayment: 'Secure payment powered by Razorpay & Stripe',
    regSuccess: 'Registration Successful!',
    checkEmail: 'Check your email for masterclass details and Zoom link.',
    joinWhatsApp: 'Join WhatsApp Group for Updates',
    whatsAppNote: 'Join the group to receive the Zoom link and bonuses',

    // Sticky Bar
    offerEnds: 'Offer ends in',
    registerNowBtn: 'Register Now',
  },

  ml: {
    // Header
    home: 'ഹോം',
    about: 'ഞങ്ങളെ കുറിച്ച്',
    programs: 'പ്രോഗ്രാമുകള്‍',
    services: 'സേവനങ്ങള്‍',
    resources: 'റിസോഴ്സസ്',
    contact: 'ബന്ധപ്പെടുക',
    signIn: 'സൈന്‍ ഇന്‍',
    getStarted: 'ആരംഭിക്കൂ',

    // Hero
    heroBadge: 'ഹീല്‍ ആന്‍ഡ് മാനിഫെസ്റ്റ് മാസ്റ്റര്‍ക്ലാസ്',
    heroHeadline1: 'ഭൂതകാലത്തില്‍ നിന്ന് സുഖം പ്രാപിക്കാനും',
    heroHeadline2: 'നിങ്ങളുടെ സ്വപ്ന ജീവിതം സൃഷ്ടിക്കാനും ശക്തമായ ടെക്നിക്കുകള്‍ പഠിക്കൂ',
    heroSocial: '',
    heroSocialBold: '10 ലക്ഷത്തിലധികം ആളുകള്‍',
    heroSocialEnd: 'വലിയ മാറ്റം അനുഭവിച്ചു',
    coachName: 'ഡോ. ദിനേശ് മുങ്ങത്ത്',
    coachCredentials: 'സംരംഭകന്‍, ഗ്രന്ഥകാരന്‍, ഹാപ്പിനസ് ലൈഫ് കോച്ച്, LOA സര്‍ട്ടിഫൈഡ് കോച്ച്, ആത്മീയ ചികിത്സകന്‍, മൈന്‍ഡ് ആര്‍കിടെക്ട്',
    morning: 'രാവിലെ',
    evening: 'വൈകുന്നേരം',
    date: 'തീയതി',
    time: 'സമയം',
    platform: 'പ്ലാറ്റ്ഫോം',
    onZoom: 'Zoom-ല്‍',
    duration: 'ദൈര്‍ഘ്യം',
    threeHours: '3 മണിക്കൂര്‍',
    signUpNow: 'ഇപ്പോള്‍ രജിസ്റ്റര്‍ ചെയ്യൂ',
    seatsFilling: 'സീറ്റുകള്‍ നിറയുന്നു!',
    seatsLeft: 'ബാക്കി',
    alreadyRegistered: 'ഇതിനകം രജിസ്റ്റര്‍ ചെയ്തു',
    morningTime: '9:30 AM - 12:30 PM (IST)',
    eveningTime: '5:30 PM - 8:30 PM (IST)',

    // Benefits
    joinTitle: 'നിങ്ങള്‍ ആഗ്രഹിക്കുന്നെങ്കില്‍ മാസ്റ്റര്‍ക്ലാസില്‍ ചേരൂ...',
    benefit1: 'ഓരോ രാവിലെയും വ്യക്തതയോടെയും ലക്ഷ്യത്തോടെയും ഉണരുക',
    benefit2: 'സമ്പത്ത്, സമൃദ്ധി, അവസരങ്ങള്‍ ആകര്‍ഷിക്കുക',
    benefit3: 'തീരുമാനങ്ങള്‍ എടുക്കുമ്പോള്‍ കൂടുതല്‍ ആത്മവിശ്വാസം നേടുക',
    benefit4: 'സ്ട്രെസ്, ഉത്കണ്ഠ, അമിത ചിന്ത എന്നിവ മറികടക്കുക',
    benefit5: 'ആരോഗ്യകരമായ, സന്തോഷകരമായ, സ്നേഹനിര്‍ഭരമായ ബന്ധം ഉണ്ടാക്കുക',
    benefit6: 'ആരോഗ്യത്തിലും മനോഭാവത്തിലും ക്രിയാത്മക മാറ്റം കാണുക',
    registerCta: 'മാസ്റ്റര്‍ക്ലാസിന് രജിസ്റ്റര്‍ ചെയ്യൂ',

    // Learnings
    learnTitle: 'മാസ്റ്റര്‍ക്ലാസില്‍ നിങ്ങള്‍ എന്ത് പഠിക്കും',
    learn1Title: 'പരിമിത വിശ്വാസങ്ങളില്‍ നിന്ന് മോചനം നേടുക',
    learn1Desc: 'നിങ്ങളെ തടഞ്ഞുനിര്‍ത്തുന്ന ആഴത്തിലുള്ള ട്രോമയും പരിമിത വിശ്വാസങ്ങളും തിരിച്ചറിയുകയും ഇല്ലാതാക്കുകയും ചെയ്യുക. പുതിയ മനോഭാവത്തോടെ മുന്നോട്ട് പോകാന്‍ പഠിക്കുക.',
    learn2Title: 'മാനിഫെസ്റ്റേഷന്‍ കല കൈവശമാക്കുക',
    learn2Desc: 'മാനിഫെസ്റ്റേഷന്‍ പിന്നിലെ ശാസ്ത്രം പഠിക്കുക. ഈ തന്ത്രങ്ങള്‍ 30,000 ആളുകളെ ആരോഗ്യം, സമ്പത്ത്, സ്നേഹം, സന്തോഷം എന്നിവ ആകര്‍ഷിക്കാന്‍ സഹായിച്ചു.',
    learn3Title: 'ആരോഗ്യകരമായ ബന്ധങ്ങള്‍ ആകര്‍ഷിക്കുക',
    learn3Desc: 'ബന്ധങ്ങളില്‍ വിഷ പാറ്റേണുകള്‍ ആവര്‍ത്തിക്കുന്നത് എങ്ങനെ നിര്‍ത്താമെന്നും പഴയ ശീലങ്ങള്‍ക്ക് പകരം പുതിയവ എങ്ങനെ നല്‍കാമെന്നും കണ്ടെത്തുക.',
    learn4Title: 'ഏത് ലക്ഷ്യവും നേടാനുള്ള 7 ഘട്ട ഫോര്‍മുല',
    learn4Desc: 'നിങ്ങളുടെ ജീവിതത്തിന്‍റെ ഏത് മേഖലയിലും എളുപ്പത്തില്‍ പ്രയോഗിക്കാവുന്ന ലളിതമായ ഒരു ഫോര്‍മുല ലഭിക്കും \u2013 ആരോഗ്യം, സമ്പത്ത്, കരിയര്‍, ബന്ധങ്ങള്‍.',

    // Video Testimonials
    videoTitle: 'മുന്‍ പങ്കാളികളുടെ ഹൃദയസ്പര്‍ശിയായ അനുഭവങ്ങള്‍',

    // Coach Section
    meetCoach: 'നിങ്ങളുടെ കോച്ചിനെ പരിചയപ്പെടൂ',
    coachBio1: 'ഡോ. ദിനേശ് 10 വര്‍ഷത്തിലധികം അനുഭവപരിചയമുള്ള ഒരു സര്‍ട്ടിഫൈഡ് ഹീലിംഗ് ആന്‍ഡ് മാനിഫെസ്റ്റേഷന്‍ കോച്ച് ആണ്.',
    coachBio2: 'ഈ വര്‍ഷങ്ങളില്‍, അദ്ദേഹം 10 ലക്ഷത്തിലധികം ആളുകളെ സ്വാധീനിക്കുകയും 30,000-ത്തിലധികം ആളുകളെ ഭൂതകാല ട്രോമകളെയും പരിമിത വിശ്വാസങ്ങളെയും മറികടക്കാന്‍ വ്യക്തിപരമായി സഹായിക്കുകയും ചെയ്തു.',
    coachBio3: 'ജാക്ക് കാന്‍ഫീല്‍ഡ്, ടോണി റോബിന്‍സ്, മരിസ പിയര്‍, ഡോ. ജോണ്‍ ഡിമാര്‍ട്ടിനി, ബ്രയന്‍ ട്രേസി, നിക്ക് വുജിസിക്, ബ്ലെയര്‍ സിംഗര്‍, റോബിന്‍ ശര്‍മ എന്നിവരുമായി അദ്ദേഹം പ്രവര്‍ത്തിച്ചിട്ടുണ്ട്.',
    coachBio4: 'ഇപ്പോള്‍ ഡോ. ദിനേശ് 1 കോടി ആളുകളെ അവരുടെ ഏറ്റവും മികച്ച പതിപ്പാക്കാന്‍ സഹായിക്കാനുള്ള ദൗത്യത്തിലാണ്.',
    followers: '10 ലക്ഷം+ ഫോളോവേഴ്സ്',
    loaCertified: 'LOA സര്‍ട്ടിഫൈഡ്',

    // Bonuses
    specialBonuses: 'പ്രത്യേക ബോണസുകള്‍',
    unlockBonuses: 'മൂല്യമുള്ള പ്രത്യേക ബോണസുകള്‍ അണ്‍ലോക്ക് ചെയ്യൂ',
    bonus1Title: '21 ദിവസ സമൃദ്ധി ചലഞ്ച്',
    bonus1Desc: 'പണത്തോടുള്ള മനോഭാവം മാറ്റാനും ദാരിദ്ര്യത്തില്‍ നിന്ന് സ്വീകരിക്കലിലേക്ക് മാറാനുമുള്ള ദൈനംദിന പരിശീലനങ്ങള്‍',
    bonus2Title: "ഹോഓപോനോപോനോ ധ്യാനം",
    bonus2Desc: 'കുറ്റബോധം, വിദ്വേഷം, തടസ്സപ്പെട്ട ഊര്‍ജ്ജം എന്നിവ ഇല്ലാതാക്കാനുള്ള ഒരു ആഴത്തിലുള്ള വൈകാരിക ശുദ്ധീകരണ ധ്യാനം',
    bonus3Title: '7 ദിവസ ലെറ്റിംഗ് ഗോ ധ്യാനം',
    bonus3Desc: 'വേദന, ആളുകള്‍, പഴയ പാറ്റേണുകള്‍ എന്നിവയില്‍ നിന്ന് വേര്‍പിരിയാനുള്ള ഒരു ഗൈഡഡ് യാത്ര',
    bonus4Title: '21 ദിവസ ചലഞ്ച് - മാറ്റിവെക്കല്‍ ശീലം മറികടക്കൂ',
    bonus4Desc: 'മാറ്റിവെക്കല്‍ ശീലം തകര്‍ക്കാനും അച്ചടക്കം വളര്‍ത്താനും ഉല്‍പാദനക്ഷമത വര്‍ദ്ധിപ്പിക്കാനുമുള്ള ദൈനംദിന പ്രവര്‍ത്തന നിര്‍ദ്ദേശങ്ങള്‍',
    bonus5Title: 'മിറക്കിള്‍ മോണിംഗ് റൂട്ടീന്‍ (90 ദിവസ ചലഞ്ച്)',
    bonus5Desc: 'ശീലങ്ങള്‍, ഫോക്കസ്, അച്ചടക്കം എന്നിവ ദീര്‍ഘകാല മാറ്റത്തിനായി വളര്‍ത്തിയെടുക്കാനുള്ള ഘടനാപരമായ 90 ദിവസ റൂട്ടീന്‍',
    bonusNote: 'കുറിപ്പ്: മാസ്റ്റര്‍ക്ലാസില്‍ പങ്കെടുത്ത ശേഷം ബോണസുകള്‍ ലഭിക്കും.',
    worth: 'മൂല്യം',

    // Success Stories
    successTitle: 'വിജയ കഥകള്‍',

    // FAQs
    faqTitle: 'പതിവ് ചോദ്യങ്ങള്‍',
    faq1Q: 'മാസ്റ്റര്‍ക്ലാസിന്‍റെ റെക്കോര്‍ഡിംഗ് ലഭിക്കുമോ?',
    faq1A: 'ഞങ്ങള്‍ റെക്കോര്‍ഡിംഗുകള്‍ നല്‍കുന്നില്ല. മികച്ച അനുഭവത്തിനായി വെബിനാറിന് നിങ്ങളുടെ കലണ്ടര്‍ ക്ലിയര്‍ ചെയ്യാന്‍ ഞങ്ങള്‍ ശുപാര്‍ശ ചെയ്യുന്നു.',
    faq2Q: 'ആര്‍ക്കൊക്കെ മാസ്റ്റര്‍ക്ലാസില്‍ പങ്കെടുക്കാം?',
    faq2A: 'ഭൂതകാല ട്രോമകള്‍, പരിമിത വിശ്വാസങ്ങള്‍ എന്നിവ മറികടക്കാനും, മനസ്സിനെ സുഖപ്പെടുത്താനും, ആത്മവിശ്വാസം വര്‍ദ്ധിപ്പിക്കാനും, ജീവിത ലക്ഷ്യങ്ങള്‍ സാക്ഷാത്കരിക്കാനും ആഗ്രഹിക്കുന്ന ആര്‍ക്കും.',
    faq3Q: 'പേയ്മെന്‍റ് ചെയ്തു, പക്ഷേ ഇമെയില്‍ ലഭിച്ചില്ല.',
    faq3A: 'info@dineshmungath.com-ല്‍ നിന്നുള്ള മെയിലിനായി നിങ്ങളുടെ ഇന്‍ബോക്സും സ്പാം ഫോള്‍ഡറും പരിശോധിക്കുക. ഇപ്പോഴും ലഭിച്ചിട്ടില്ലെങ്കില്‍, അതേ ഐഡിയിലേക്ക് മെയില്‍ അയയ്ക്കുക.',
    faq4Q: 'മാസ്റ്റര്‍ക്ലാസില്‍ എങ്ങനെ ചേരാം?',
    faq4A: 'WhatsApp ഗ്രൂപ്പിലും നിങ്ങളുടെ രജിസ്റ്റര്‍ ചെയ്ത ഇമെയിലിലും കുറച്ച് മണിക്കൂറുകള്‍ക്ക് മുമ്പ് Zoom ഇന്‍വൈറ്റ് ലഭിക്കും.',
    faq5Q: 'ബോണസുകള്‍ എപ്പോള്‍ ലഭിക്കും?',
    faq5A: 'മാസ്റ്റര്‍ക്ലാസില്‍ പങ്കെടുത്ത ശേഷം എല്ലാ ബോണസുകളും ലഭിക്കും.',

    // Register
    registerNow: 'ഇപ്പോള്‍ രജിസ്റ്റര്‍ ചെയ്യൂ',
    limitedSeats: 'പരിമിതമായ സീറ്റുകള്‍ മാത്രം',
    yourName: 'നിങ്ങളുടെ പൂര്‍ണ്ണ നാമം',
    yourEmail: 'നിങ്ങളുടെ ഇമെയില്‍',
    yourPhone: 'നിങ്ങളുടെ ഫോണ്‍ നമ്പര്‍',
    payIndia: 'പേയ് ചെയ്യൂ',
    payIndiaMethod: '(ഇന്ത്യ - Razorpay)',
    payIntl: '$1.19 USD പേയ് ചെയ്യൂ (അന്താരാഷ്ട്ര - Stripe)',
    securePayment: 'Razorpay & Stripe വഴി സുരക്ഷിത പേയ്മെന്‍റ്',
    regSuccess: 'രജിസ്ട്രേഷന്‍ വിജയകരം!',
    checkEmail: 'മാസ്റ്റര്‍ക്ലാസ് വിശദാംശങ്ങള്‍ക്കും Zoom ലിങ്കിനുമായി നിങ്ങളുടെ ഇമെയില്‍ പരിശോധിക്കുക.',
    joinWhatsApp: 'അപ്ഡേറ്റുകള്‍ക്ക് WhatsApp ഗ്രൂപ്പില്‍ ചേരൂ',
    whatsAppNote: 'Zoom ലിങ്കും ബോണസുകളും ലഭിക്കാന്‍ ഗ്രൂപ്പില്‍ ചേരൂ',

    // Sticky Bar
    offerEnds: 'ഓഫര്‍ അവസാനിക്കുന്നു',
    registerNowBtn: 'ഇപ്പോള്‍ രജിസ്റ്റര്‍ ചെയ്യൂ',
  }
};
